var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#3091F3",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.625 12.4989V8.74891C15.625 6.98115 15.625 6.09726 15.0758 5.54809C14.5956 5.06785 13.8594 5.00757 12.5 5H7.5C6.14061 5.00757 5.40441 5.06785 4.92417 5.54809C4.375 6.09726 4.375 6.98115 4.375 8.74891V12.4989C4.375 14.2667 4.375 15.1506 4.92417 15.6997C5.47335 16.2489 6.35723 16.2489 8.125 16.2489H11.875C13.6428 16.2489 14.5267 16.2489 15.0758 15.6997C15.625 15.1506 15.625 14.2667 15.625 12.4989Z",
    fill: "#3091F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.6875C7.5 4.16973 7.91973 3.75 8.4375 3.75H11.5625C12.0803 3.75 12.5 4.16973 12.5 4.6875V5.3125C12.5 5.83027 12.0803 6.25 11.5625 6.25H8.4375C7.91973 6.25 7.5 5.83027 7.5 5.3125V4.6875Z",
    fill: "#3091F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40625 9.0625C6.40625 8.80362 6.61612 8.59375 6.875 8.59375H7.1875C7.44638 8.59375 7.65625 8.80362 7.65625 9.0625C7.65625 9.32138 7.44638 9.53125 7.1875 9.53125H6.875C6.61612 9.53125 6.40625 9.32138 6.40625 9.0625ZM8.59375 9.0625C8.59375 8.80362 8.80362 8.59375 9.0625 8.59375H13.125C13.3839 8.59375 13.5937 8.80362 13.5937 9.0625C13.5937 9.32138 13.3839 9.53125 13.125 9.53125H9.0625C8.80362 9.53125 8.59375 9.32138 8.59375 9.0625ZM6.40625 11.25C6.40625 10.9911 6.61612 10.7812 6.875 10.7812H7.1875C7.44638 10.7812 7.65625 10.9911 7.65625 11.25C7.65625 11.5089 7.44638 11.7187 7.1875 11.7187H6.875C6.61612 11.7187 6.40625 11.5089 6.40625 11.25ZM8.59375 11.25C8.59375 10.9911 8.80362 10.7812 9.0625 10.7812H13.125C13.3839 10.7812 13.5937 10.9911 13.5937 11.25C13.5937 11.5089 13.3839 11.7187 13.125 11.7187H9.0625C8.80362 11.7187 8.59375 11.5089 8.59375 11.25ZM6.40625 13.4375C6.40625 13.1786 6.61612 12.9687 6.875 12.9687H7.1875C7.44638 12.9687 7.65625 13.1786 7.65625 13.4375C7.65625 13.6964 7.44638 13.9062 7.1875 13.9062H6.875C6.61612 13.9062 6.40625 13.6964 6.40625 13.4375ZM8.59375 13.4375C8.59375 13.1786 8.80362 12.9687 9.0625 12.9687H13.125C13.3839 12.9687 13.5937 13.1786 13.5937 13.4375C13.5937 13.6964 13.3839 13.9062 13.125 13.9062H9.0625C8.80362 13.9062 8.59375 13.6964 8.59375 13.4375Z",
    fill: "#3091F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.c023422ea9e8b2cb30716624be1bc6e0.svg";
export { ForwardRef as ReactComponent };